var arabam;
(function (arabam) {
    var breadcrumbCompareController = /** @class */ (function () {
        function breadcrumbCompareController(CompareService, $rootScope, HttpHelperService) {
            var _this = this;
            this.CompareService = CompareService;
            this.$rootScope = $rootScope;
            this.HttpHelperService = HttpHelperService;
            this.popupEl = null;
            this.toggleButton = null;
            this.isPopupVisible = false;
            this.cars = [];
            this.differentCategoryError = false;
            this.maxLimitError = false;
            // getMember = () => {
            //   const self = this;
            //   self.HttpHelperService.httpGet(
            //     "/home/memberInfo?random=" + new Date().getTime(),
            //     (response: any) => {
            //       // console.log("memberInfo", response);
            //       if (response.Data) {
            //         this.isUserLoggedIn = true;
            //         this.cars = this.CompareService.comparables;
            //         this.listenEvents();
            //       }
            //     }
            //   );
            // };
            this.listenEvents = function () {
                _this.$rootScope.$on("compareListChanged", function () {
                    console.log("compareListChanged breadcrumbCompareController");
                    // get initial values
                    _this.cars = _this.CompareService.comparables;
                    _this.maxLimitError = _this.CompareService.maxLimitError;
                    _this.showPopupForAWhile();
                });
                _this.$rootScope.$on("compareErrorCheck", function () {
                    console.log("compareErrorCheck breadcrumbCompareController");
                    _this.maxLimitError = _this.CompareService.maxLimitError;
                    _this.differentCategoryError = _this.CompareService.differentCategoryError;
                    _this.showPopupForAWhile();
                    // if (
                    //   this.CompareService.maxLimitError ||
                    //   this.CompareService.differentCategoryError
                    // ) {
                    //   this.writeLocalStorage();
                    //   this.showPopupForAWhile();
                    // }
                });
            }; // .end listenEvents
            this.onClickOutside = function (event) {
                var target = event.target;
                if (event.target != _this.toggleButton) {
                    if (!_this.popupEl.contains(target))
                        _this.hidePopup();
                }
            };
            this.init();
        }
        // isUserLoggedIn: boolean = false;
        breadcrumbCompareController.prototype.init = function () {
            // this.cars = this.CompareService.comparables;
            this.popupEl = document.getElementById("comparePopup");
            this.toggleButton = document.getElementById("compareButton");
            // this.getMember();
            this.cars = this.CompareService.comparables;
            this.listenEvents();
        };
        // writeLocalStorage = function() {
        //   try {
        //     localStorage.setItem("compareCollapsed", this.minimized);
        //   } catch (e) {
        //     return false;
        //   }
        //   return true;
        // };
        breadcrumbCompareController.prototype.togglePopup = function (event) {
            if (this.isPopupVisible) {
                this.hidePopup();
            }
            else {
                this.showPopup();
            }
        };
        breadcrumbCompareController.prototype.showPopup = function () {
            // console.log("showing popup");
            this.popupEl.classList.add("show");
            this.isPopupVisible = true;
            document.addEventListener("click", this.onClickOutside, false);
        };
        breadcrumbCompareController.prototype.hidePopup = function () {
            // console.log("hiding popup");
            this.popupEl.classList.remove("show");
            this.isPopupVisible = false;
            document.removeEventListener("click", this.onClickOutside, false);
        };
        breadcrumbCompareController.prototype.showPopupForAWhile = function () {
            var _this = this;
            if (this.popupTimeout) {
                clearTimeout(this.popupTimeout);
            }
            this.showPopup();
            this.popupTimeout = setTimeout(function () {
                _this.hidePopup();
            }, 1000 * 60 * 3);
        };
        breadcrumbCompareController.prototype.removeCarFromCompareList = function (event, carId) {
            event.stopPropagation();
            event.preventDefault();
            this.CompareService.remove(carId);
        };
        breadcrumbCompareController.prototype.clearList = function (event) {
            var _this = this;
            event.stopPropagation();
            event.preventDefault();
            this.cars.forEach(function (item) {
                _this.CompareService.remove(item.id);
            });
        };
        breadcrumbCompareController.prototype.goToCompareClicked = function () {
            if (this.cars.length > 1) {
                var ids = "";
                for (var i = 0; i < this.cars.length; i++) {
                    var car = this.cars[i];
                    ids = ids + car.id + (i < this.cars.length - 1 ? "_" : "");
                }
                window.location.href = "/ilan/karsilastir/" + ids;
            }
        };
        breadcrumbCompareController.$inject = ["CompareService", "$rootScope", "HttpHelperService"];
        return breadcrumbCompareController;
    }());
    angular.module("arabam").controller("breadcrumbCompareController", breadcrumbCompareController);
})(arabam || (arabam = {}));
